
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component({ name: 'BaseTooltip' })
export default class BaseTooltip extends Vue {
  @Prop() tooltipText ?: string

  @Prop({ default: 'left' }) position! : 'left' | 'right'

  @Prop({ default: 'dark' }) theme! : 'dark' | 'light'

  private themes : Record<string, string> = {
    dark: 'bg-black text-white',
    light: 'bg-white text-black shadow',
  }

  private get positionStyles () : Record<string, string> {
    return {
      left: `right-[calc(100%+24px)] after:left-full after:top-1/2 after:-translate-y-1/2 ${
        this.theme === 'dark' ? 'after:border-l-black' : 'after:border-l-white'
      }`,
      right: `left-[calc(100%+24px)] after:right-full after:top-1/2 after:-translate-y-1/2 ${
        this.theme === 'dark' ? 'after:border-r-black' : 'after:border-r-white'
      }`,
    }
  }
}
